import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";



export default function ManagmentGrid({onClose}:{onClose: () => void}) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4">
      <NavLink to={"/managment/maintenance"} onClick={() => onClose()} className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary ">
        <span className="font-medium text-base">{t('repair_and_service')}</span>
        <span className="text-sm text-muted-foreground">{t('repair_and_service_desc')}</span>
      </NavLink>
      <NavLink to={"/managment/tracking"} onClick={() => onClose()} className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary ">
        <span className="font-medium text-base">{t('tracking')}</span>
        <span className="text-sm text-muted-foreground">{t('tracking_desc')}</span>
      </NavLink>
      <NavLink to={"/managment/staff_tabel"} onClick={() => onClose()} className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary ">
        <span className="font-medium text-base">{t('staff_tabel')}</span>
        <span className="text-sm text-muted-foreground">{t('staff_tabel_desc')}</span>
      </NavLink>
    </div>
  )
} 